import helper, { isMobile } from "../common/Helper";
import ContentLoader from 'react-content-loader';

const BlogMainBannerSection = ({ blogDetail, isLoading }) => {
    let locImg = helper.S3Url + '/' + helper.blogImageDir + '/' + (blogDetail?.image ? blogDetail?.image : blogDetail?.listing_image);
    let MobImg = helper.S3Url + '/' + helper.blogImageDir + '/' + (blogDetail?.listing_image ? blogDetail?.listing_image : blogDetail?.image);

    return (

        <>
            {
                isLoading ?
                    // <div className="container-fluid">
                    <ContentLoader
                        backgroundColor="#e0e0d9"
                        foregroundColor="#d6d6d0"
                        viewBox={`0 0 ${window.innerWidth} 490`}
                        width="100%"
                        height="490"
                    >
                        <rect x="0" y="0" rx="0" ry="0" width="100%" height="490" />
                    </ContentLoader>
                    // </div>
                    :
                    <section className="mainBanner mb-5" style={{ backgroundImage: `url(${isMobile() ? MobImg : locImg})` }}>
                        <div className="bannerBox">
                            <div className="container">
                                <div className="bannerText">
                                    <div className="sliderText">

                                        <h2>{blogDetail?.name}</h2>
                                        <p>{blogDetail?.short_description}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
            }

        </>
    )
}
export default BlogMainBannerSection;